<template lang="html">
  <div class="row general-info-row">
    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ activeTeachers }}
        </div>
        <div class="general-info-label mt3">Active Teachers</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="active_teachers_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ activeStudents }}
        </div>
        <div class="tc general-info-label mt3">Active Students</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="active_students_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ numberOnlineActivitiesCreated }}
        </div>
        <div class="tc general-info-label mt3">Written RoundTables Created</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="roundtable_discussions_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ numberOnlineActivitiesRun }}
        </div>
        <div class="tc general-info-label mt3">Written RoundTables Run</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="roundtable_discussions_run_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ numberLiveActivitiesCreated }}
        </div>
        <div class="tc general-info-label mt3">Verbal RoundTables Created</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="roundtable_discussions_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ numberLiveActivitiesRun }}
        </div>
        <div class="tc general-info-label mt3">Verbal RoundTables Run</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="roundtable_discussions_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
    <div class="general-info-card pl-box-shadow pa2 items-center flex">
      <div class="center">
        <div class="tc general-info-data mt3">
          {{ topicsUsed }}
        </div>
        <div class="general-info-label mt3">Universe Topics Used</div>
        <div class="tc mt3">
          <i
            v-my-tooltip="topics_used_tooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {},
    data() {
      return {
        active_teachers_tooltip:
          'This is the number of teachers who have created at least one RoundTable (and students were invited) between the dates selected.',
        active_students_tooltip:
          'This is the number of students who have been invited to at least one RoundTable between the dates selected.',
        roundtable_discussions_tooltip:
          'This is the total number of RoundTables that were created by teachers in this school/district between the dates selected.',
        roundtable_discussions_run_tooltip:
          'This is the total number of RoundTables with invited students that were created by teachers in this school/district between the dates selected.',
        topics_used_tooltip:
          'This is the number of discussion topics that have been used by teachers in this school/district between the dates selected.',
      };
    },
    props: {
      activeTeachers: {
        type: Number,
        default: 0,
      },
      activeStudents: {
        type: Number,
        default: 0,
      },
      numberOnlineActivitiesCreated: {
        type: Number,
        default: 0,
      },
      numberLiveActivitiesCreated: {
        type: Number,
        default: 0,
      },
      numberOnlineActivitiesRun: {
        type: Number,
        default: 0,
      },
      numberLiveActivitiesRun: {
        type: Number,
        default: 0,
      },
      topicsUsed: {
        type: Number,
        default: 0,
      },
    },
  };
</script>
<style scoped lang="stylus">
  .general-info-row
    display: flex;
    justify-content: flex-start;

  .general-info-card
    width: 180px;
    margin: 0 8px 20px 8px

  .general-info-data
    font-size: 32px
    font-weight: 600

  .general-info-label
    height: 40px;
    max-width: 100px;
    font-size: 16px;
    text-align:center
</style>



// WEBPACK FOOTER //
// adminPortalAnalyticsGeneralInfo.vue?4100bef8